import React from 'react';
import { SvgIcon, Button, UI, HeroIconName } from '@gik/ui';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';
import { useInkind } from '@gik/api/inkinds/inkind';
import isInkindPageRecipientInfoComplete from '@gik/inkind-page/utils/isInkindPageRecipientInfoComplete';
import ContactPageOrganizersForAddress from '@gik/calendar';

interface CopyInfoCardProps {
  title: string;
  icon: HeroIconName;
  content: string[];
  inkindRouteId?: string;
  recipientAddressRequired?: boolean;
}

export default function CopyInfoCard({
  title,
  icon,
  content,
  inkindRouteId,
  recipientAddressRequired,
}: CopyInfoCardProps): React.ReactElement {
  const { t } = useTranslation();
  const { data: inkindPage } = useInkind(inkindRouteId);

  const contentValid = !inkindPage || !recipientAddressRequired || isInkindPageRecipientInfoComplete(inkindPage);
  console.log(
    title,
    inkindRouteId,
    inkindPage !== null,
    recipientAddressRequired,
    inkindPage && isInkindPageRecipientInfoComplete(inkindPage)
  );

  function onCopyAddressClicked() {
    copy(content.join('\n'));
    UI.notifySuccess(t(translationKeys.copied));
  }

  return (
    <div className="external-product-interstitial-copy-info-card">
      <header>
        <SvgIcon name={icon} />
        <span>{title}</span>
      </header>
      {contentValid ? (
        <>
          <main>
            <div>
              {content
                .filter(line => line?.trim().length > 0)
                .map((line, index) => [<span key={index + '-line'}>{line}</span>, <br key={index + '-br'} />])}
            </div>
          </main>
          <Button variant="primary-light-outline" circle onClick={onCopyAddressClicked}>
            <SvgIcon name="DuplicateOutline" />
          </Button>
        </>
      ) : (
        <ContactPageOrganizersForAddress inkindRouteId={inkindRouteId} variant="interstitial" />
      )}
    </div>
  );
}
